import { render, staticRenderFns } from "./appTable.vue?vue&type=template&id=609e2dbc&scoped=true"
import script from "./appTable.vue?vue&type=script&lang=js"
export * from "./appTable.vue?vue&type=script&lang=js"
import style0 from "./appTable.vue?vue&type=style&index=0&id=609e2dbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609e2dbc",
  null
  
)

export default component.exports